import { currencyCodes } from '../../locale/currencies';

interface Plan {
  id: string;
  name: string;
  description: string;
}

export const cawPlans: Plan[] = currencyCodes.map(currency => ({
  // Legacy plans use lowercase currency codes
  id: `climate-action-workforce-${currency.toLowerCase()}`,
  name: `Climate Action Workforce`,
  description: `The Climate Action Workforce subscription plan`,
}));

export const isCawPlan = (planId: string) => cawPlans.map(p => p.id).includes(planId);
